export const en = {
    contains: 'contains',
    'day-placeholder': 'dd',
    'incorrect-date': 'Incorrect date',
    'month-placeholder': 'mm',
    'not-contains': 'doesn’t contain',
    'year-placeholder': 'yyyy'
};
